var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _vm.loading_folders
            ? _vm._l(3, function (i, index) {
                return _c(
                  "v-col",
                  { key: "skeleton-" + index, attrs: { md: "4" } },
                  [_c("CardSkeletonList")],
                  1
                )
              })
            : [
                _vm._l(_vm.folderData.sub_folder, function (folder, index) {
                  return _c(
                    "v-col",
                    {
                      key: "folder-" + index,
                      attrs: { cols: "12", sm: "6", md: "3" },
                    },
                    [
                      _c("CardFolder", {
                        attrs: { folder: folder, legajo_id: _vm.legajo_id },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("open-folder", folder)
                          },
                          editItem: function ($event) {
                            return _vm.$emit("editItem", folder)
                          },
                          deleteItem: function ($event) {
                            return _vm.$emit("deleteItem", folder)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                _vm._l(_vm.folderData.documents, function (file, index) {
                  return _c(
                    "v-col",
                    {
                      key: "file-" + index,
                      attrs: { cols: "12", sm: "6", md: "3" },
                    },
                    [
                      _c("CardFile", {
                        attrs: { file: file },
                        on: {
                          deleteItemFile: function ($event) {
                            return _vm.$emit("deleteItemFile", file)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                (!_vm.folderData.sub_folder ||
                  !_vm.folderData.sub_folder.length) &&
                (!_vm.folderData.documents || !_vm.folderData.documents.length)
                  ? _c("ListEmpty", {
                      attrs: {
                        title: "Aun no existen documentos en esta carpeta",
                        description:
                          "Crea una carpeta o un nuevo documento para comenzar a organizar tus archivos.",
                      },
                    })
                  : _vm._e(),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }